const ResizeFitModes = {
  CLAMP: 'clamp',
  CLIP: 'clip',
  CROP: 'crop',
  FACEAREA: 'facearea',
  FILL: 'fill',
  FILLMAX: 'fillmax',
  MAX: 'max',
  MIN: 'min',
  SCALE: 'scale',
};

module.exports = ResizeFitModes;
